<template>
  <v-app>
    <drawer-menu v-model="drawer"></drawer-menu>
    <v-toolbar app fixed clipped-left color="primary">
      <v-toolbar-side-icon class="white--text" @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="white--text"><a href="/" class="white--text">{{title}}</a></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat :title="$vuetify.t('$vuetify.app.menu.save_toserver')" @click="clickExportBikes" v-if="isStateToSave(state)" :disabled="!online">
        <v-icon class="white--text">save_alt</v-icon>
      </v-btn>
      <v-menu bottom left v1-if="menuItems.length != 0">
        <v-btn slot="activator" icon class="white--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="menu in menuItems" :key="menu.id" @click="menuClicked(menu)">
            <v-list-tile-avatar>
              <v-icon>{{menu.icon}}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ menu.title }}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile @click="clearStorage">
            <v-list-tile-avatar>
              <v-icon>block</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title v-html="$vuetify.t('$vuetify.app.menu.clear_storage')">
              Clear Storage
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile @click="toBookmarkUrl" v-if="uuid && uuid != ''">
            <v-list-tile-avatar>
              <v-icon>bookmark_border</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title v-html="$vuetify.t('$vuetify.app.menu.bookmark')">
              Bookmark URL
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile @click="refreshExport" v-if="uuid && uuid != ''" :disabled="!online">
            <v-list-tile-avatar>
              <v-icon>cached</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title v-html="$vuetify.t('$vuetify.app.menu.refresh')">
              Refresh
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile @click="$vuetify.lang.current ='de'" v-if="$vuetify.lang.current != 'de'">
            <v-list-tile-avatar>
              <v-icon>language</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>
              Deutsch
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile @click="$vuetify.lang.current ='en'" v-if="$vuetify.lang.current != 'en'">
            <v-list-tile-avatar>
              <v-icon>language</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>
              English
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </v-container>
    </v-content>
    <v-footer class="pa-3">
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }}
        <router-link to="/inprint" v-html="$vuetify.t('$vuetify.inprint.title')"></router-link>
      </div>
    </v-footer>

    <v-dialog v-model="exportDialog" max-width="380">
      <v-card>
        <v-card-title class="headline" v-html="$vuetify.t('$vuetify.app.dialog.store_title')">Store everything on server?</v-card-title>
        <v-card-text v-html="$vuetify.t('$vuetify.app.dialog.store_msg')">
          <!--If you aggree all bikes will be stored on a server and could be accessed by the user id. <br>-->
          <!--Besite the bikes, no data will be stored. For backup purposes store your user id, later you can add these backup to an other device or reload for backup.<br>-->
          <!--If you disagree, every stays only stored in your browser and will be deleted if you erased your browser localstorage.-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat outline @click="exportDialog = false" v-html="$vuetify.t('$vuetify.disagree')">
            Disagree
          </v-btn>
          <v-btn flat outline color="green" @click="exportDialog = false; exportBikes();" v-html="$vuetify.t('$vuetify.agree')">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bookmarkDialog" max-width="400px">
      <v-card max-width="400px">
        <v-card-title><h1>Bookmark/Share</h1></v-card-title>
        <v-card-text>
          <div>Scanne diesen QR Code mit deinem Android gerät oder speichere dir die <a target="_blank" :href="'/'+uuid" style="max-width: 350px">Adresse</a></div>
          <v-layout justify-center>
            <VueQrcode :value="uuid" :options="{ width: 200 }"></VueQrcode>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="bookmarkDialog = false" flat outline color="green">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import StoreMixin from './mixins/StorageState'
  import StringMixin from './mixins/StringMixin'
  import DrawerMenu from './components/DrawerMenu';
  import VueQrcode from '@chenfengyuan/vue-qrcode';
  import {eventBus} from './main';

  export default {
    name: 'app',
    components: {
      DrawerMenu,
      VueQrcode
    },
    mixins: [StoreMixin, StringMixin],
    data() {
      return {
        drawer: false,
        menuItems: [],
        exportDialog: false,
        bookmarkDialog: false,
        title: '',
      }
    },
    computed: {
      ...mapGetters(['state', 'uuid']),
      userUuid() {
        return this.uuid == null ? '' : this.uuid;
      },
      online() {
        return navigator.onLine;
      }
    },
    methods: {
      ...mapActions(['exportBikes', 'importBikes', 'refreshExport']),
      isStateToSave(state) {
        return this.isUnsavedState(state);
      },
      clearStorage() {
        localStorage.clear();
        window.location.href = '/';
      },
      menuClicked(item) {
        eventBus.$emit('menu-selected', item.id);
      },
      toBookmarkUrl() {
        // this.$router.push('/' + this.uuid);
        this.bookmarkDialog = true;
      },
      clickExportBikes() {
        if (this.isNullOrEmpty(this.uuid)) {
          this.exportDialog = true;
        } else {
          this.exportBikes();
        }
      },
    },
    mounted(e) {
      eventBus.$on('title-change', function (e) {
        document.title = e;
        this.title = e;
      }.bind(this));
      eventBus.$on('menu-change', function (e) {
        if (e.menu) {
          this.menuItems = e.menu;
        }
      }.bind(this));
      // if (window.location.href.startsWith('http://localhost')) {
      //   this.createNewSettings();
      // }
      this.$store.commit('initMe', this.$vuetify);
    }
  }
</script>

<style scoped>
  body {
    margin: 0;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  main {
    text-align: center;
  }

  header {
    margin: 0;
    height: 56px;
    padding: 0 16px 0 24px;
    background-color: #35495E;
    color: #ffffff;
  }

  header span {
    display: block;
    position: relative;
    font-size: 20px;
    line-height: 1;
    letter-spacing: .02em;
    font-weight: 400;
    box-sizing: border-box;
    padding-top: 16px;
  }

  a {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue